import React, { useEffect, useState } from 'react';
import { emailShot, advancedSearch, preAdvancedSearch, getCandidate, getContact } from './../API';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { flexCenterRight } from './../theme';
import { Spin, Tooltip, Select, Table, Result, Form, Checkbox, Input, Row, Col, Radio, Modal, Button, Icon, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
// import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
import CustomAvatar from './../components/customAvatar';
import CandidateDetail from './../components/candidateDetail';
import ContactDetail from './../components/contactDetail';
import { s3, readFileAsync, editorConfig } from './../utils';
import { allNations } from './../utils/countries';
import Flag from "react-country-flags";
import { navigate } from "@reach/router"

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

const { Option } = Select;

function Search() {
  const nations = allNations();

  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const search = useMappedState(state => state.search);

  const [searchDetailID, setSearchDetailID] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const [showEmailshotModal, setShowEmailshotModal] = useState(false);

  const [loading, setLoading] = useState(true);

  const [personType, setPersonType] = useState(null);
  const [searchData, setSearchData] = useState(null);

  const [selectAll, setSelectAll] = useState(true);
  const [selectAllArr, setSelectAllArr] = useState([]);

  const [showCreateSearchModal, setShowCreateSearchModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const response = await preAdvancedSearch(session.authToken);
      dispatch({type: "INIT_PRESEARCH", payload: response.data.data});
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "8"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  const CreateSearch = ({form}) => {
    const { getFieldDecorator } = form;

    const [loading, setLoading] = useState(false);

    const [searchType, setSearchType] = useState("cv");

    const [fieldType, setFieldType] = useState("candidate");

    const [anddeleting, setAnddeleting] = useState(false);
    const [cvAndKeywords, setCvAndKeywords] = useState([{value: '', checked: false}]);

    const [ordeleting, setOrdeleting] = useState(false);
    const [cvOrKeywords, setCvOrKeywords] = useState([]);

    const [candidateField1Deleting, setCandidateField1Deleting] = useState(false);
    const [candidateField1, setCandidateField1] = useState([]);

    const [candidateField2Deleting, setCandidateField2Deleting] = useState(false);
    const [candidateField2, setCandidateField2] = useState([]);

    const [candidateField3Deleting, setCandidateField3Deleting] = useState(false);
    const [candidateField3, setCandidateField3] = useState([]);

    const [candidateField4Deleting, setCandidateField4Deleting] = useState(false);
    const [candidateField4, setCandidateField4] = useState([]);

    const [candidateField5Deleting, setCandidateField5Deleting] = useState(false);
    const [candidateField5, setCandidateField5] = useState([]);


    const [contactField1Deleting, setContactField1Deleting] = useState(false);
    const [contactField1, setContactField1] = useState([]);

    const [contactField2Deleting, setContactField2Deleting] = useState(false);
    const [contactField2, setContactField2] = useState([]);

    const [contactField3Deleting, setContactField3Deleting] = useState(false);
    const [contactField3, setContactField3] = useState([]);

    const [contactField4Deleting, setContactField4Deleting] = useState(false);
    const [contactField4, setContactField4] = useState([]);

    const buildCVQuery = (form) => {
      let query = "";
      let orArr = [];
      for (let i = 0; i < cvOrKeywords.length; i++) {
        let or;
        if (form[`or-check-${i}`]) {
          or = `starred = true and not fullText contains '${form[`or-${i}`]}'`
        }
        else {
          or = `starred = true and fullText contains '${form[`or-${i}`]}'`
        }

        let andArr = [];
        for (let i = 0; i < cvAndKeywords.length; i++) {
          let and;
          if (form[`and-check-${i}`]) {
            and = `not fullText contains '${form[`and-${i}`]}'`
          }
          else {
            and = `fullText contains '${form[`and-${i}`]}'`
          }
          andArr.push(and)
        }

        const andString = andArr.join(" and ");
        const orStirng = or+" and "+andString;
        orArr.push(orStirng);
      }

      query = orArr.join(" or ");

      if (query !== "") {
        return query;
      }
      else {

        let andArr = [];
        for (let i = 0; i < cvAndKeywords.length; i++) {
          let and;
          if (form[`and-check-${i}`]) {
            and = `not fullText contains '${form[`and-${i}`]}'`
          }
          else {
            and = `fullText contains '${form[`and-${i}`]}'`
          }
          andArr.push(and)
        }
        const andString = andArr.join(" and ");

        return "starred = true and "+andString
      }
    }

    const handleOnSubmit = async () => {
      const formResult = await form.validateFields();

      setLoading(true);
      if (searchType === "cv") {
        const query = buildCVQuery(formResult);

        const response = await advancedSearch(
          session.authToken,
          "cv",
          {query}
        );

        if (response.data.responseCode === 0) {
          setSelectAll(true)
          setSelectAllArr([])

          setPersonType("candidate");
          setSearchData([]); //clear search data first
          setSearchData(response.data.data.map(i => {
            return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          }));
          setShowCreateSearchModal(false);
          message.success(response.data.message);
        }
        else {
          setLoading(false);
          message.error(response.data.message);
        }
      }

      if (searchType === "field") {
        let query;

        if (fieldType === "candidate") {
          const services = [];
          const positions = [];
          const locations = [];
          const regions = [];
          const countries = [];

          for (let i = 0; i < candidateField1.length; i++) {
            services.push(formResult[`candidate-field-1-${i}`])
          }

          for (let i = 0; i < candidateField2.length; i++) {
            positions.push(formResult[`candidate-field-2-${i}`])
          }

          for (let i = 0; i < candidateField3.length; i++) {
            locations.push(formResult[`candidate-field-3-${i}`])
          }

          for (let i = 0; i < candidateField4.length; i++) {
            regions.push(formResult[`candidate-field-4-${i}`])
          }

          for (let i = 0; i < candidateField5.length; i++) {
            countries.push(formResult[`candidate-field-5-${i}`])
          }

          query = {
            type: "candidate",
            services,
            positions,
            locations,
            regions,
            countries
          }
        }

        if (fieldType === "contact") {
          const departments = [];
          const positions = [];
          const cities = [];
          const countries = [];

          for (let i = 0; i < contactField1.length; i++) {
            departments.push(formResult[`contact-field-1-${i}`])
          }

          for (let i = 0; i < contactField2.length; i++) {
            positions.push(formResult[`contact-field-2-${i}`])
          }

          for (let i = 0; i < contactField3.length; i++) {
            cities.push(formResult[`contact-field-3-${i}`])
          }

          for (let i = 0; i < contactField4.length; i++) {
            countries.push(formResult[`contact-field-4-${i}`])
          }

          query = {
            type: "contact",
            departments,
            positions,
            cities,
            countries,
          }
        }

        const response = await advancedSearch(
          session.authToken,
          "field",
          {query}
        );

        if (response.data.responseCode === 0) {
          setSelectAll(true)
          setSelectAllArr([])

          setSearchData([]); //clear search data first
          setSearchData(response.data.data.map(i => {
            return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          }));

          if (fieldType === "candidate") {
            setPersonType("candidate");
          }

          if (fieldType === "contact") {
            setPersonType("contact");
          }

          setShowCreateSearchModal(false);
          message.success(response.data.message);
        }
        else {
          setLoading(false);
          message.error(response.data.message);
        }
      }
    }

    const handleOnOrDelete = async (index) => {
      setOrdeleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < cvOrKeywords.length; i++) {
        arr.push({value: formResult[`or-${i}`], checked: formResult[`or-check-${i}`]})
      }
      arr.splice(index, 1);
      setCvOrKeywords(arr);
      setOrdeleting(false)
    }

    const handleOnAndDelete = async (index) => {
      setAnddeleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < cvAndKeywords.length; i++) {
        arr.push({value: formResult[`and-${i}`], checked: formResult[`and-check-${i}`]})
      }
      arr.splice(index, 1);
      setCvAndKeywords(arr);
      setAnddeleting(false)
    }

    const handleOnContactF1Delete = async (index) => {
      setContactField1Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < contactField1.length; i++) {
        arr.push({value: formResult[`contact-field-1-${i}`]})
      }
      arr.splice(index, 1);
      setContactField1(arr);
      setContactField1Deleting(false)
    }

    const handleOnContactF2Delete = async (index) => {
      setContactField2Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < contactField2.length; i++) {
        arr.push({value: formResult[`contact-field-2-${i}`]})
      }
      arr.splice(index, 1);
      setContactField2(arr);
      setContactField2Deleting(false)
    }

    const handleOnContactF3Delete = async (index) => {
      setContactField3Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < contactField3.length; i++) {
        arr.push({value: formResult[`contact-field-3-${i}`]})
      }
      arr.splice(index, 1);
      setContactField3(arr);
      setContactField3Deleting(false)
    }

    const handleOnContactF4Delete = async (index) => {
      setContactField4Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < contactField4.length; i++) {
        arr.push({value: formResult[`contact-field-4-${i}`]})
      }
      arr.splice(index, 1);
      setContactField4(arr);
      setContactField4Deleting(false)
    }

    const handleOnCF1Delete = async (index) => {
      setCandidateField1Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < candidateField1.length; i++) {
        arr.push({value: formResult[`candidate-field-1-${i}`]})
      }
      arr.splice(index, 1);
      setCandidateField1(arr);
      setCandidateField1Deleting(false)
    }

    const handleOnCF2Delete = async (index) => {
      setCandidateField2Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < candidateField2.length; i++) {
        arr.push({value: formResult[`candidate-field-2-${i}`]})
      }
      arr.splice(index, 1);
      setCandidateField2(arr);
      setCandidateField2Deleting(false)
    }

    const handleOnCF3Delete = async (index) => {
      setCandidateField3Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < candidateField3.length; i++) {
        arr.push({value: formResult[`candidate-field-3-${i}`]})
      }
      arr.splice(index, 1);
      setCandidateField3(arr);
      setCandidateField3Deleting(false)
    }

    const handleOnCF4Delete = async (index) => {
      setCandidateField4Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < candidateField4.length; i++) {
        arr.push({value: formResult[`candidate-field-4-${i}`]})
      }
      arr.splice(index, 1);
      setCandidateField4(arr);
      setCandidateField4Deleting(false)
    }

    const handleOnCF5Delete = async (index) => {
      setCandidateField5Deleting(true);
      const formResult = await form.getFieldsValue();
      const arr = []
      for (let i = 0; i < candidateField5.length; i++) {
        arr.push({value: formResult[`candidate-field-5-${i}`]})
      }
      arr.splice(index, 1);
      setCandidateField5(arr);
      setCandidateField5Deleting(false)
    }

    const renderCVPanel = () => {
      return(
        <Row>
          <Col span={1} />
          <Col span={10}>

            <Row>
              <Col span={5} />
              <Col span={17}>
                <center>AND</center>
              </Col>
              <Col span={2} />
            </Row>
            <br/>
            {
             !anddeleting ?
             cvAndKeywords.map((i, k) => (
              <Row key={k}>
                <Col span={5}>
                <center style={{marginTop: "8px"}}>
                  {getFieldDecorator(`and-check-${k}`, {
                    initialValue: i.checked,
                    valuePropName: 'checked'
                  })(<Checkbox disabled={loading}>Not</Checkbox>)}
                </center>
                </Col>
                <Col span={17}>
                  <Form.Item>
                    {getFieldDecorator(`and-${k}`, {
                      initialValue: i.value,
                      rules: [{ required: true, message: 'Please input keyword!' }],
                    })(
                    <Input autoComplete="off" disabled={loading} placeholder="Keyword" />
                    )}
                  </Form.Item>
                </Col>
                <Col span={2}>
                  {
                    cvAndKeywords.length > 1 ?
                    <center style={{marginTop: '8px'}}>
                    <Icon type="delete" onClick={() => {handleOnAndDelete(k)}} />
                    </center>
                    :
                    null
                  }
                </Col>
              </Row>
             ))
             :
             null
            }

            <Row>
              <Col span={5} />
              <Col span={17}>
              <Button
                type="dashed"
                onClick={() => {
                  setCvAndKeywords([...cvAndKeywords, ...[{value: '', checked: false}]])
                }}
                style={{ width: '100%' }}
              >
                <Icon type="plus" /> Add Keyword
              </Button>
              </Col>
              <Col span={2} />
            </Row>

          </Col>

          <Col span={2} />
          <Col span={10}>

          <Row>
              <Col span={5} />
              <Col span={17}>
                <center>OR</center>
              </Col>
              <Col span={2} />
            </Row>
            <br/>
            {
             !ordeleting ?
             cvOrKeywords.map((i, k) => (
              <Row key={k}>
                <Col span={5}>
                <center style={{marginTop: "8px"}}>
                  {getFieldDecorator(`or-check-${k}`, {
                    initialValue: i.checked,
                    valuePropName: 'checked'
                  })(<Checkbox disabled={loading}>Not</Checkbox>)}
                </center>
                </Col>
                <Col span={17}>
                  <Form.Item>
                    {getFieldDecorator(`or-${k}`, {
                      initialValue: i.value,
                      rules: [{ required: true, message: 'Please input keyword!' }],
                    })(
                    <Input autoComplete="off" disabled={loading} placeholder="Keyword" />
                    )}
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <center style={{marginTop: '8px'}}>
                  <Icon type="delete" onClick={() => {handleOnOrDelete(k)}} />
                  </center>
                </Col>
              </Row>
             ))
             :
             null
            }

            <Row>
              <Col span={5} />
              <Col span={17}>
              <Button
                type="dashed"
                onClick={() => {
                  setCvOrKeywords([...cvOrKeywords, ...[{value: '', checked: false}]])
                }}
                style={{ width: '100%' }}
              >
                <Icon type="plus" /> Add Keyword
              </Button>
              </Col>
              <Col span={2} />
            </Row>

          </Col>
          <Col span={1} />
        </Row>
      )
    }

    const renderFieldCandidate = () => {
      return(
        <Row>
          <Col span={4}>

          {/*********** Candidate Field 1 ***********/}
          <Row>
            <Col span={20}>
              <center>Service</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !candidateField1Deleting ?
          candidateField1.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`candidate-field-1-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.candidate.services.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnCF1Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setCandidateField1([...candidateField1, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Candidate Field 1 ***********/}

          </Col>

          <Col span={1} />

          <Col span={4}>

          {/*********** Candidate Field 2 ***********/}
          <Row>
            <Col span={20}>
              <center>Position</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !candidateField2Deleting ?
          candidateField2.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`candidate-field-2-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.candidate.positions.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnCF2Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setCandidateField2([...candidateField2, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Candidate Field 2 ***********/}

          </Col>

          <Col span={1} />

          <Col span={4}>

          {/*********** Candidate Field 3 ***********/}
          <Row>
            <Col span={20}>
              <center>Location</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !candidateField3Deleting ?
          candidateField3.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`candidate-field-3-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.candidate.locations.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnCF3Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setCandidateField3([...candidateField3, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Candidate Field 3 ***********/}

          </Col>

          <Col span={1} />

          <Col span={4}>

          {/*********** Candidate Field 4 ***********/}
          <Row>
            <Col span={20}>
              <center>Region</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !candidateField4Deleting ?
          candidateField4.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`candidate-field-4-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.candidate.regions.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnCF4Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setCandidateField4([...candidateField4, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Candidate Field 4 ***********/}


          </Col>

          <Col span={1} />

          <Col span={4}>

          {/*********** Candidate Field 5 ***********/}
          <Row>
            <Col span={20}>
              <center>Country</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !candidateField5Deleting ?
          candidateField5.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`candidate-field-5-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      optionLabelProp="label"
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        nations.map(i => (
                          <Option key={i} value={i.name} label={i.name}>
                            <Row>
                              <Col span={6}>
                                <Flag country={i.code} asSquare={true} style={{width: '30px', height: '20px'}}/>
                              </Col>
                              <Col>
                                {i.name}
                              </Col>
                            </Row>
                        </Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnCF5Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setCandidateField5([...candidateField5, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Candidate Field 5 ***********/}


          </Col>

        </Row>
      )
    }

    const renderFieldContact = () => {
      return(
        <Row>
          <Col span={5}>

          {/*********** Contact Field 1 ***********/}
          <Row>
            <Col span={20}>
              <center>Department</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !contactField1Deleting ?
          contactField1.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`contact-field-1-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.contact.departments.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnContactF1Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setContactField1([...contactField1, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Contact Field 1 ***********/}


          </Col>

          <Col span={1} />

          <Col span={5}>

          {/*********** Contact Field 2 ***********/}
          <Row>
            <Col span={20}>
              <center>Position</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !contactField2Deleting ?
          contactField2.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`contact-field-2-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.contact.positions.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnContactF2Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setContactField2([...contactField2, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Contact Field 2 ***********/}


          </Col>

          <Col span={1} />

          <Col span={5}>

          {/*********** Contact Field 3 ***********/}
          <Row>
            <Col span={20}>
              <center>City</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !contactField3Deleting ?
          contactField3.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`contact-field-3-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      placeholder="Keyword"
                    >
                      {
                        search.contact.cities.map((i, k) => (
                        <Option key={k} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnContactF3Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setContactField3([...contactField3, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Contact Field 3 ***********/}


          </Col>

          <Col span={1} />

          <Col span={5}>

          {/*********** Contact Field 4 ***********/}
          <Row>
            <Col span={20}>
              <center>Country</center>
            </Col>
            <Col span={4} />
          </Row>
          <br/>
          {
          !contactField4Deleting ?
          contactField4.map((i, k) => (
            <Row key={k}>
              <Col span={20}>
                <Form.Item>
                  {getFieldDecorator(`contact-field-4-${k}`, {
                    initialValue: i.value,
                    rules: [{ required: true, message: 'Please select keyword!' }],
                  })(
                    <Select
                      disabled={loading}
                      showSearch
                      style={{width: "100%"}}
                      optionLabelProp="label"
                      placeholder="Keyword"
                    >
                      {
                        nations.map(i => (
                          <Option key={i} value={i.name} label={i.name}>
                            <Row>
                              <Col span={6}>
                                <Flag country={i.code} asSquare={true} style={{width: '30px', height: '20px'}}/>
                              </Col>
                              <Col>
                                {i.name}
                              </Col>
                            </Row>
                        </Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={4}>
                <center style={{marginTop: '8px'}}>
                <Icon type="delete" onClick={() => {handleOnContactF4Delete(k)}} />
                </center>
              </Col>
            </Row>
          ))
          :
          null
          }

          <Row>
            <Col span={20}>
            <Button
              type="dashed"
              onClick={() => {
                setContactField4([...contactField4, ...[{value: null}]])
              }}
              style={{ width: '100%' }}
            >
              <Icon type="plus" /> Add Keyword
            </Button>
            </Col>
            <Col span={4} />
          </Row>
          {/*********** End of Contact Field 4 ***********/}


          </Col>
        </Row>
      )
    }

    const renderFieldPanel = () => {
      return(
        <React.Fragment>
          <div>
          Person Type:&nbsp;&nbsp;&nbsp;
          <Radio.Group onChange={(e) => {
            if (e.target.value === 'candidate') {
              setContactField1([]);
              setContactField2([]);
              setContactField3([]);
              setContactField4([]);
            }
            if (e.target.value === 'contact') {
              setCandidateField1([]);
              setCandidateField2([]);
              setCandidateField3([]);
              setCandidateField4([]);
              setCandidateField5([]);
            }
            setFieldType(e.target.value);
            }} value={fieldType}>
            <Radio value={"candidate"}>Candidate</Radio>
            <Radio value={"contact"}>Contact</Radio>
          </Radio.Group>
          </div>
          <br/>
          {
            fieldType === 'candidate' ?
            renderFieldCandidate()
            :
            renderFieldContact()
          }
        </React.Fragment>
      )
    }

    return(
      <Modal
        centered={true}
        title="Create Search"
        closable={false}
        visible={showCreateSearchModal}
        width={searchType === "cv" ? 800 : 1100}
        maxHeight={500}
        footer={[
          <Button disabled={loading} key="cancel" onClick={() => {
            setShowCreateSearchModal(false);
          }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button disabled={loading} type="primary" key="submit" onClick={handleOnSubmit}>
            {
              loading ?
              <Icon type="loading" />
              :
              <Icon type="check" />
            }
            Search
          </Button>
        ]}
      >
        <div>
        Type:&nbsp;&nbsp;&nbsp;
        <Radio.Group onChange={(e) => {
          if (e.target.value === 'cv') {
            setCandidateField1([]);
            setCandidateField2([]);
            setCandidateField3([]);
            setCandidateField4([]);
            setCandidateField5([]);

            setContactField1([]);
            setContactField2([]);
            setContactField3([]);
            setContactField4([]);
          }
          if (e.target.value === 'field') {
            setCvAndKeywords([{value: '', checked: false}]);
            setCvOrKeywords([]);
          }
          setSearchType(e.target.value);
          }} value={searchType}>
          <Radio value={"cv"}>CVs</Radio>
          <Radio value={"field"}>Fields</Radio>
        </Radio.Group>
        </div>
        <br/>
        {
          searchType === 'cv' ?
          renderCVPanel()
          :
          renderFieldPanel()
        }
      </Modal>
    )
  }
  const CreateSearchForm = Form.create({ name: 'create-search' })(CreateSearch);


  const renderContactContent = () => {
    const columns = [
      {
        title: <Tooltip title={selectAll ? "Unselect All" : "Select All"}>
          <Checkbox onClick={() => {
            setSelectAll(!selectAll);
            setSelectAllArr([]);
          }} checked={selectAll}></Checkbox>
        </Tooltip>,
        width: '1%',
        key: 'checkbox',
        render: (contact) =>
          selectAll ?
          <CustomCheckedbox data={contact}/>
          :
          <CustomUnCheckedbox data={contact}/>
      },
      {
        title: '',
        width: '1%',
        key: 'avatar',
        render: (contact) =>
        <CustomAvatar
          colourCode={contact.firstname.charAt(0).toLowerCase()}
          char={`${contact.firstname.charAt(0).toUpperCase()}${contact.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${contact.id}.jpeg`}
        />
      },
      {
        title: '',
        width: '1%',
        dataIndex: 'salutation',
        key: 'salutation',
      },
      {
        title: 'Name',
        width: '10%',
        dataIndex: 'fullname',
        sorter: (a, b) => a.fullname.localeCompare(b.fullname),
        key: 'fullname',
      },
      {
        title: 'Department',
        width: '10%',
        dataIndex: 'department',
        sorter: (a, b) => a.service.localeCompare(b.service),
        key: 'department',
      },
      {
        title: 'Position',
        width: '10%',
        dataIndex: 'position',
        sorter: (a, b) => a.position.localeCompare(b.position),
        key: 'position',
      },
      {
        title: '',
        width: '10%',
        render: (contact) => <div style={flexCenterRight}>
          <Button size="small" onClick={() => {
            setSearchDetailID(contact.id)
            setShowDetailModal(true)
          }}><Icon type="plus" /> Details</Button>
        </div>
      }
    ];

    return(
      <Table
        columns={columns}
        dataSource={searchData}
        rowKey="id"
      />
    )
  }

  const CustomCheckedbox = (props) => {
    const [value, setValue] = useState(selectAllArr.includes(props.data.id) ? false : true);

    const handleSelectAllTrue = (event, props) => {
      setValue(!value);
      if (event.target.checked) {
        setSelectAllArr(selectAllArr.filter(i => i !== props.data.id))
      }
      else {
        setSelectAllArr([...selectAllArr, ...[props.data.id]])
      }
    }

    return(
      <Checkbox
        onClick={(event) => {handleSelectAllTrue(event, props)}}
        checked={value}
      />
    )
  }

  const CustomUnCheckedbox = (props) => {
    const [value, setValue] = useState(selectAllArr.includes(props.data.id) ? true : false);

    const handleSelectAllFalse = (event, props) => {
      setValue(!value);
      if (event.target.checked) {
        setSelectAllArr([...selectAllArr, ...[props.data.id]])
      }
      else {
        setSelectAllArr(selectAllArr.filter(i => i !== props.data.id))
      }
    }
    return(
      <Checkbox
        onClick={(event) => {handleSelectAllFalse(event, props)}}
        checked={value}
      />
    )
  }

  const renderCandidateContent = () => {

    const columns = [
      {
        title: <Tooltip title={selectAll ? "Unselect All" : "Select All"}>
          <Checkbox onClick={() => {
            setSelectAll(!selectAll);
            setSelectAllArr([]);
          }} checked={selectAll}></Checkbox>
        </Tooltip>,
        width: '1%',
        key: 'checkbox',
        render: (candidate) =>
          selectAll ?
          <CustomCheckedbox data={candidate}/>
          :
          <CustomUnCheckedbox data={candidate}/>
      },
      {
        title: '',
        width: '1%',
        key: 'avatar',
        render: (candidate) =>
        <CustomAvatar
          colourCode={candidate.firstname.charAt(0).toLowerCase()}
          char={`${candidate.firstname.charAt(0).toUpperCase()}${candidate.lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${candidate.id}.jpeg`}
        />
      },
      {
        title: '',
        width: '1%',
        dataIndex: 'salutation',
        key: 'salutation',
      },
      {
        title: 'Name',
        width: '10%',
        dataIndex: 'fullname',
        sorter: (a, b) => a.fullname.localeCompare(b.fullname),
        key: 'fullname',
      },
      {
        title: 'Service',
        width: '10%',
        dataIndex: 'service',
        sorter: (a, b) => a.service.localeCompare(b.service),
        key: 'service',
      },
      {
        title: 'Position',
        width: '10%',
        dataIndex: 'position',
        sorter: (a, b) => a.position.localeCompare(b.position),
        key: 'position',
      },
      {
        title: '',
        width: '10%',
        render: (candidate) => <div style={flexCenterRight}>
          <Button size="small" onClick={() => {
            setSearchDetailID(candidate.id);
            setShowDetailModal(true);
          }}><Icon type="plus" /> Details</Button>
        </div>
      }
    ];

    return(
      <Table
        columns={columns}
        dataSource={searchData}
        rowKey="id"
      />
    )
  }

  const MailshotModal = ({form}) => {
    const { getFieldDecorator } = form;

    let recipients;
    if (selectAll) {
      recipients = searchData.filter(i => !selectAllArr.includes(i.id));
    }
    else {
      recipients = searchData.filter(i => selectAllArr.includes(i.id));
    }

    const [submitting, setSubmitting] = useState(false);
    const [emailBody, setEmailBody] = useState(null);
    // eslint-disable-next-line
    const [attachment, setAttachment] = useState([]);
    
    const handleOnMailShotSubmit = async () => {
      const formResult = await form.validateFields();

      setSubmitting(true)

      const fileList = [];
      for (const each of attachment) {
        const file = await readFileAsync(each)
        fileList.push({
          name: each.name,
          type: each.type,
          data: file.replace(/data:.+,/, ""),
        })
      }

      const newRecipients = [];
      for (const each of recipients) {
        newRecipients.push({
          id: each._id,
          firstname: each.firstname,
          lastname: each.lastname,
          email: each.email
        });

        if (each.email1 && each.email1 !== "") {
          newRecipients.push({
            id: each._id,
            firstname: each.firstname,
            lastname: each.lastname,
            email: each.email1
          });
        }

        if (each.email2 && each.email2 !== "") {
          newRecipients.push({
            id: each._id,
            firstname: each.firstname,
            lastname: each.lastname,
            email: each.email2
          });
        }
      }

      const params = {
        type: personType,
        recipient: newRecipients,
        subject: formResult.email_subject,
        body: emailBody ? emailBody.toHTML() : "",
        attachment: fileList
      }

      const response = await emailShot(session.authToken, params);

      if (response.data.responseCode === 0) {
        setShowEmailshotModal(false);
        setSubmitting(false);
        message.success(response.data.message);
      }
      else {
        setSubmitting(false);
        message.error(response.data.message);
      }
    }

    return(
      <Modal
        centered={true}
        title="MailShot"
        closable={false}
        visible={showEmailshotModal}
        width={800}
        footer={[
          <Button disabled={submitting} key="cancel" onClick={() => {
            setShowEmailshotModal(false);
          }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button disabled={recipients.length === 0 ? true : submitting}
            type="primary" key="submit" onClick={handleOnMailShotSubmit}>
            {
              submitting ?
              <Icon type="loading" />
              :
              <Icon type="check" />              
            }
            Submit
          </Button>
        ]}
      >
        {
          recipients.length > 0 ?
          <React.Fragment>
            <div>Total {recipients.length} recipient(s) selected</div>
            <br/>
            <div>
            <Form.Item>
              {getFieldDecorator('email_subject', {
                rules: [{ required: true, message: 'Please input subject!' }],
              })(
                <Input autoComplete="off" placeholder="Subject" disabled={submitting} />
              )}
            </Form.Item>
            <CKEditor
              disabled={submitting}
              value={emailBody}
              data={emailBody}
              editor={ Editor }
              config= { editorConfig }
              onChange={ ( event, editor ) => {
                const data = editor.getData();
                setEmailBody(data);
              }}
            />
            <br/>
            <Row>
              <Col span={12}>
              {/* <Upload {...{
                accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
                multiple: true,
                showUploadList: true,
                onRemove: file => {
                  setAttachment(attachment.filter(i => i.uid !== file.uid));
                },
                beforeUpload: (_, fileList) => {
                  setAttachment([...attachment, ...fileList])
                  return false;
                },
                attachment,
              }}>
                <Tooltip placement="right" title={"Allowed file types are image, pdf, doc, docx, xls, xlsx, ppt, pptx"}>
                  <Button disabled={submitting}>
                    <FontAwesomeIcon icon={faPaperclip} />&nbsp;&nbsp;Attachments
                  </Button>
                </Tooltip>
              </Upload> */}
              </Col>
            </Row>

            </div>
          </React.Fragment>
          :
          <div>Recipient not available, please select at least one recipient.</div>
        }
      </Modal>
    )
  }

  const MailshotModalForm = Form.create({ name: 'mail-shot-modal' })(MailshotModal);

  const SearchDetailModal = () => {
    const [loading, setLoading] = useState(true);
    const [detailData, setDetailData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        let response;

        if (personType === 'candidate') {
          response = await getCandidate(session.authToken, searchDetailID);
          setDetailData(response.data.candidate)
        }
        else {
          response = await getContact(session.authToken, searchDetailID);
          setDetailData(response.data.contact)
        }

        setLoading(false);
      }
      fetchData();
    // eslint-disable-next-line
    }, []);

    return(
      <Modal
        centered={true}
        title={personType === 'candidate' ? 'Candidate Detail' : 'Contact Detail'}
        closable={false}
        visible={showDetailModal}
        width={loading ? 800 : 1100}
        footer={[
          <Button disabled={loading} key="cancel" onClick={() => {
            setShowDetailModal(false);
            setSearchDetailID(null);
          }}>
            <Icon type="close" />
            Close
          </Button>
          ,
          <Button disabled={loading} key="goto" type="primary" onClick={() => {
            if (personType === "candidate") {
              navigate(`/candidates/${searchDetailID}`);
            }
            else {
              navigate(`/contacts/${searchDetailID}`);
            }
          }}>
            <Icon type="arrow-right" />
            Go To Page
          </Button>
        ]}
      >
        {
          loading ?
          <center><Spin spinning={loading} indicator={<Icon type="loading" />} />&nbsp;&nbsp;Loading...</center>
          :
          personType === 'candidate' ?
          <CandidateDetail data={detailData} />
          :
          <ContactDetail data={detailData} />
        }
      </Modal>
    )
  }

  return (
    <React.Fragment>

      <CreateSearchForm />

      {
        showEmailshotModal ?
        <MailshotModalForm />
        :
        null
      }

      {
        showDetailModal ?
        <SearchDetailModal />
        :
        null
      }

      <Row>
        <Col span={12}>
        {
          searchData !== null && searchData.length > 0 ?
          <React.Fragment>
            <Tooltip title="Mailshot disabled">
              <Button disabled onClick={() => {
                setShowEmailshotModal(true);
              }}><Icon type="mail" /> Mailshot</Button>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
          </React.Fragment>
          :
          null
        }
        {
          searchData !== null ?
          <React.Fragment>
            <Button onClick={() => {
              setPersonType(null)
              setSearchData(null)
              setSelectAll(true)
              setSelectAllArr([])
            }}><Icon type="delete" /> Clear</Button>
          </React.Fragment>
          :
          null
        }
        </Col>

        <Col span={12}>
          <div style={flexCenterRight}>
            <Button disabled={loading} type="primary" onClick={() => {
              setShowCreateSearchModal(true)
            }}>
              {
                loading ?
                <Icon type="loading" />
                :
                <Icon type="plus-square" />
              }
               Create Search</Button>
          </div>
        </Col>
      </Row>

      <br/>

      <div>
        {
          searchData === null ?
          <Result
            icon= {<FontAwesomeIcon style={{color: "#408EBA", fontSize: "45px"}} icon={faSearch} />}
            title="You don't have any data yet, please create a search first!"
          />
          :
          <div>
            {
              personType === 'candidate' ?
              renderCandidateContent()
              :
              renderContactContent()
            }
          </div>
        }
      </div>
    </React.Fragment>
  );
}

export default Search;
